export default {
      id: "logo-apple-24-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "assets/iconset.svg#logo-apple-24",
      toString: function () {
        return this.url;
      }
    }